import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import {createBrowserRouter, RouterProvider} from 'react-router';
import {routes} from './routes';

// Production's Rails-served HTML hardcodes only assets/index.css, so any
// other CSS Vite emits is never linked. Force a dynamic import of the
// modals chunk at startup so Vite's preload-helper injects modals.css via
// JS at runtime regardless of the route's chunk graph.
// Remove once floorplanner-site reads Vite's manifest.json.
void import('@/components/modals');

const router = createBrowserRouter(routes);

createRoot(document.getElementById('root')!).render(
    <StrictMode>
        <RouterProvider router={router} />
    </StrictMode>
);
